import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../components/pages/authentication/authentication/authentication.service';
import { PermissionTypeEnum } from '../common/permission-enum';

@Directive({
	selector: '[appCheckPermission]'
})
export class CheckPermissionDirective implements OnInit {

	@Input() appCheckPermission: number[] = [0];
	@Input() permissionType: PermissionTypeEnum = PermissionTypeEnum.NONE;

	constructor(
		private element: ElementRef,
		private authService: AuthenticationService
	) {
	}

	ngOnInit(): void {
		const permissions = this.authService.getPermissions();
		if (permissions) {
			for (let i = 0; i < this.appCheckPermission.length; i++) {
				const element = this.appCheckPermission[i];
				for (let i = 0; i < permissions.length; i++) {
					const tempPermission = permissions[i];
					if (tempPermission['roleId'] == element) {
						if (this.permissionType == PermissionTypeEnum.ALL){
							return;
						} else {
							switch(this.permissionType){
								case PermissionTypeEnum.CREATE: {
									if (tempPermission.create){
										return;
									}
									break;
								}
								case PermissionTypeEnum.DELETE: {
									if (tempPermission.delete){
										return;
									}
									break;
								}
								case PermissionTypeEnum.UPDATE: {
									if (tempPermission.update){
										return;
									}
									break;
								}
								case PermissionTypeEnum.READ: {
									if (tempPermission.read){
										return;
									}
									break;
								}
								default: {
									break;
								}
							}
						}
						break;
					}
				}
			}
			this.element.nativeElement?.remove();
		}
	}
}
